/**
 * @generated SignedSource<<4af08d0e32ba824d9cfd94a7d0660ed8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type unified_ingest_transform_file_params = {
  file_id: string;
  owner_name: string;
  template_id: string;
};
export type useUnifiedIngestTransformFileMutation$variables = {
  params: unified_ingest_transform_file_params;
};
export type useUnifiedIngestTransformFileMutation$data = {
  readonly unified_ingest_transform_file: {
    readonly file_id: string;
    readonly owner_name: string;
  };
};
export type useUnifiedIngestTransformFileMutation = {
  response: useUnifiedIngestTransformFileMutation$data;
  variables: useUnifiedIngestTransformFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "unified_ingest_transform_file_output",
    "kind": "LinkedField",
    "name": "unified_ingest_transform_file",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner_name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnifiedIngestTransformFileMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnifiedIngestTransformFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1dbc2a59a20e08c71937510774d5f2ff",
    "id": null,
    "metadata": {},
    "name": "useUnifiedIngestTransformFileMutation",
    "operationKind": "mutation",
    "text": "mutation useUnifiedIngestTransformFileMutation(\n  $params: unified_ingest_transform_file_params!\n) {\n  unified_ingest_transform_file(params: $params) {\n    file_id\n    owner_name\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed858368bacbc3aa5b2507406d4c0133";

export default node;
